import { type ComponentType, type ReactElement, type ReactNode } from 'react';

import Placeholder from '@atlaskit/react-ufo/placeholder';
import UFOSegment from '@atlaskit/react-ufo/segment';

export type PlaceholderComponentProps = {
	children: ReactNode;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	fallback: any;
	name: string;
};

export type UFOSegmentComponentProps = {
	children: ReactNode;
	name: string;
};

export type Config = {
	ModalOnError: (props: { error: Error }) => ReactElement<any, any> | null;
	PlaceholderComponent: ComponentType<PlaceholderComponentProps>;
	UFOSegmentComponent: ComponentType<UFOSegmentComponentProps>;
};

const DefaultUFOSegmentComponent = UFOSegment;

const entryPointConfig = {
	PlaceholderComponent: Placeholder,
	UFOSegmentComponent: DefaultUFOSegmentComponent,
	ModalOnError: () => null,
};

export function initEntryPointConfig(overrides: Partial<Config>): Config {
	Object.assign(entryPointConfig, overrides);
	return entryPointConfig;
}

export function useEntryPointConfig(): Config {
	return entryPointConfig;
}
